// ===============作业管理===========
import request from "../index";
import to from "@/utils/await-to";
import reqTip from "@/utils/requestTip";

//----------------作业登记-----------

//获取作业登记列表
export async function getHwRegisterList(data) {
	let req = request({
		url: "/assbe/homework/teacher/list",
		method: "post",
		data,
	});
	const [err, res] = await to(req);
	if (err || !res || res.result != "000000") {
		err
			? reqTip.showNetworkError(err)
			: reqTip.showReqError(res, "获取作业登记列表失败，请稍后再试");
		return null;
	}
	return res.data || [];
}

//新增作业登记
export async function addHwRegister(data) {
	let req = request({
		url: "/assbe/homework/teacher/add",
		method: "post",
		data,
	});
	const [err, res] = await to(req);
	if (err || !res || res.result != "000000") {
		err ? reqTip.showNetworkError(err) : reqTip.showReqError(res, res.desc);
		return null;
	}
	reqTip.showSuccess("新增作业登记成功");
	return true;
}

//修改作业登记
export async function updateHwRegister(data) {
	let req = request({
		url: "/assbe/homework/teacher/update",
		method: "post",
		data,
	});
	const [err, res] = await to(req);
	if (err || !res || res.result != "000000") {
		err ? reqTip.showNetworkError(err) : reqTip.showReqError(res, "修改作业登记失败，请稍后再试");
		return null;
	}
	reqTip.showSuccess("修改作业登记成功");
	return true;
}

//删除作业登记
export async function deleteHwRegister(data) {
	let req = request({
		url: "/assbe/homework/teacher/delete",
		method: "post",
		data,
	});
	const [err, res] = await to(req);
	if (err || !res || res.result != "000000") {
		err ? reqTip.showNetworkError(err) : reqTip.showReqError(res, "删除作业失败，请稍后再试");
		return null;
	}
	return true;
}

//查询作业详细信息 详情
export async function getHwDetail(params) {
	let req = request({
		url: "/assbe/homework/teacher/deteil",
		method: "get",
		params,
	});
	const [err, res] = await to(req);
	if (err || !res || res.result != "000000") {
		err ? reqTip.showNetworkError(err) : reqTip.showReqError(res, "查询作业详情失败，请稍后再试");
		return null;
	}
	return res.data || [];
}

//查询班级作业信息列表
export async function getClassHwList(data) {
	let req = request({
		url: "/assbe/homework/teacher/classhomework",
		method: "post",
		data,
	});
	const [err, res] = await to(req);
	if (err || !res || res.result != "000000") {
		err
			? reqTip.showNetworkError(err)
			: reqTip.showReqError(res, "查询班级作业信息列表失败，请稍后再试");
		return null;
	}
	return res.data || [];
}

//----------------作业调控-----------
//查询作业调控信息列表 老师
export async function getControlList(data) {
	let req = request({
		url: "/assbe/homework/teacher/control",
		method: "post",
		data,
	});
	const [err, res] = await to(req);
	if (err || !res || res.result != "000000") {
		err
			? reqTip.showNetworkError(err)
			: reqTip.showReqError(res, "查询作业调控信息失败，请稍后再试");
		return null;
	}
	return res.data || [];
}
//查询作业调控信息列表 学校
// export function getSchoolControlList(data) {
// 	return request({
// 		url: "/assbe/homework/school/control",
// 		method: "post",
// 		data,
// 	});
// }
export async function getSchoolControlList(data) {
	let req = request({
		url: "/assbe/homework/school/control",
		method: "post",
		data,
	});
	const [err, res] = await to(req);
	if (err || !res || res.result != "000000") {
		err
			? reqTip.showNetworkError(err)
			: reqTip.showReqError(res, "查询学校作业调控信息失败，请稍后再试");
		return null;
	}
	return res.data || [];
}

//----------------作业反馈-----------
//查询课程反馈列表 个人
export async function getHwFeedbackList(data) {
	let req = request({
		url: "/assbe/homework/teacher/feedbacklist",
		method: "post",
		data,
	});
	const [err, res] = await to(req);
	if (err || !res || res.result != "000000") {
		err
			? reqTip.showNetworkError(err)
			: reqTip.showReqError(res, "获取作业反馈列表失败，请稍后再试");
		return null;
	}
	return res.data || [];
}

//查询课程反馈列表 学校
export async function getSchHwFeedbackList(data) {
	let req = request({
		url: "/assbe/homework/school/feedback",
		method: "post",
		data,
	});
	const [err, res] = await to(req);
	if (err || !res || res.result != "000000") {
		err
			? reqTip.showNetworkError(err)
			: reqTip.showReqError(res, "获取学校作业反馈列表失败，请稍后再试");
		return null;
	}
	return res.data || [];
}

//查询作业反馈详细信息
export async function getHwFeedbackDetail(data) {
	let req = request({
		url: "/assbe/homework/teacher/feedbackInfo",
		method: "post",
		data,
	});
	const [err, res] = await to(req);
	if (err || !res || res.result != "000000") {
		err
			? reqTip.showNetworkError(err)
			: reqTip.showReqError(res, "获取作业反馈详情失败，请稍后再试");
		return null;
	}
	return res.data || [];
}

//用户反馈
export function addFeedback(data) {
	return request({
		url: "/assbe/homework/teacher/add/feedback",
		method: "post",
		data,
	});
}

//删除反馈
export function deleteFeedback(data) {
	return request({
		url: "/assbe/homework/teacher/delete/feedback",
		method: "post",
		data,
	});
}

//查询课程反馈列表
// export function getHwFeedbackList(data) {
// 	return request({
// 		url: "/assbe/homework/teacher/feedbacklist",
// 		method: "post",
// 		data,
// 	});
// }

//查询作业反馈详细信息
// export function getHwFeedbackList(data) {
// 	return request({
// 		url: "/assbe/homework/teacher/feedbackInfo",
// 		method: "post",
// 		data,
// 	});
// }
//----------------作业备案-----------
//年级备案列表查询
export async function getRecordList(data) {
	let req = request({
		url: "/assbe/homework/school/graderecord",
		method: "post",
		data,
	});
	const [err, res] = await to(req);
	if (err || !res || res.result != "000000") {
		err
			? reqTip.showNetworkError(err)
			: reqTip.showReqError(res, "查询年级备案列表失败，请稍后再试");
		return null;
	}
	return res.data || [];
}

//作业审核
export async function HwAudit(data) {
	let req = request({
		url: "/assbe/homework/school/audit",
		method: "post",
		data,
	});
	const [err, res] = await to(req);
	if (err || !res || res.result != "000000") {
		err ? reqTip.showNetworkError(err) : reqTip.showReqError(res, "审核失败，请稍后再试");
		return null;
	}

	if (data.state == "11") {
		reqTip.showSuccess("审核通过");
	} else {
		reqTip.showSuccess("审核不通过");
	}
	return true;
}

//作业批量审核
export async function BatchHwAudit(data) {
	let req = request({
		url: "/assbe/homework/school/batchaudit",
		method: "post",
		data,
	});
	const [err, res] = await to(req);
	if (err || !res || res.result != "000000") {
		err ? reqTip.showNetworkError(err) : reqTip.showReqError(res, "审核失败，请稍后再试");
		return null;
	}
	return true;
}

//作业审核信息列表
export async function fetchReviewList(params) {
	let req = request({
		url: "/assbe/homework/school/reviewlist",
		method: "get",
		params,
	});
	const [err, res] = await to(req);
	if (err || !res || res.result != "000000") {
		err
			? reqTip.showNetworkError(err)
			: reqTip.showReqError(res, "查询作业审核信息列表失败，请稍后再试");
		return null;
	}
	return res.data || [];
}
